// globalState.js  
let timer = null;  
  
import { ref } from 'vue'
const timeIntValue = ref(0)
  
const startTimer = () => {  
    if (!timer) {

        // 当前时间
		const date = new Date()
		// 当前时间
		timeIntValue.value = parseInt(date.valueOf() / 1000)

        timer = setInterval(() => {
            timeIntValue.value += 1;  
        }, 1000);
    }  
};  

const stopTimer = () => {  
    if (timer) {  
        clearInterval(timer);  
        timer = null;  
    }  
};  
  
export { timeIntValue, startTimer, stopTimer };